module.exports = [{"name":"@username@","value":"username"},{"name":"@unitavendita@","value":"chosenUV"},{"name":"@zona@","value":"chosenZona"},{"name":"@siuUtente@","value":"SIUToken"},{"name":"@anno@","value":"@anno@"},{"name":"@mese@","value":"@mese@"},{"name":"@giorno@","value":"@giorno@"}]


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/utils/dictionary.json
// module id = ../../../../../src/app/utils/dictionary.json
// module chunks = main